<template>
<v-container fluid class="pa-0">
	<!--get info-->
	<v-form v-model="valid" ref="form" validation>
		<v-container>
			<v-row>
				<v-col cols="12" sm="4" md="2">
					<v-select dense
						v-model="gameId"
						:items="games"
						color="#1A237E"
						item-color="grey"
						label="game id"
						required
						:rules="requiredRules">
					</v-select>
				</v-col>
				<v-col cols="12" sm="2" md="1">
					<v-select dense
						v-model="round"
						:items="items"
						color="#1A237E"
						item-color="grey"
						label="round"
						required
						:rules="requiredRules">
					</v-select>
				</v-col>
				<v-col cols="12" sm="3" md="2" class="mt-4">
					<v-btn color="#1A237E" small dark
						class="text-lowercase"
						:disabled="!valid || Boolean(error)"
						@click="getInfo"
						>load
					</v-btn>	
				</v-col>
				<v-col cols="12" class="mt-4" sm="3" md="2" v-if="valid && chainRout()">
					<add-chain :gameId="gameId" :round="round"></add-chain>
				</v-col>
				<v-col cols="12" class="mt-4" sm="3" md="2" v-else-if="valid">
					<add-segment :gameId="gameId" :round="round"></add-segment>
				</v-col>
			</v-row>
		</v-container>
	</v-form>
	<!--segments-->
	<v-divider class="mt-4"></v-divider>

	<v-tabs v-model="tab" height="35"
		align-with-title
		background-color="primary"
		dark>
		<v-tab :to="link(item)" ripple
			class="text-capitalize"
			exact-active-class
			v-for="item in itemsTab"
			:key="item">
			{{ item }}
		</v-tab>
	</v-tabs>

	<v-tabs-items v-model="tab" continuous>
		<v-tab-item value="/admin/market/segments">
			<segments :gameId="gameId" :round="round"></segments>
		</v-tab-item>
		<v-tab-item value="/admin/market/media">
			<media :gameId="gameId" :round="round"></media>
		</v-tab-item>
		<v-tab-item value="/admin/market/design">
			<design :gameId="gameId" :round="round"></design>
		</v-tab-item>
		<v-tab-item value="/admin/market/materials">
			<materials :gameId="gameId" :round="round"></materials>
		</v-tab-item>
		<v-tab-item value="/admin/market/chains">
			<chains :gameId="gameId" :round="round"></chains>
		</v-tab-item>
	</v-tabs-items>
</v-container>
</template>
<script>
	import Segments from './market/Segments.vue'
	import Media from './market/Media.vue'
	import Design from './market/Design.vue'
	import Materials from './market/Materials.vue'
	import Chains from './market/IndependentChains.vue'

	import addSegment from './market/modal/addSegment.vue'
	import addChain from './market/modal/addChain.vue'
	
	export default {
		data (){
			return {
				valid: false,
				error: '',
				round: '0',
				items: ['0', '1', '2', '3', '4', '5', '6', '7', '8'],
				requiredRules: [v => !!v || 'this field is required'],
				tab: 0,
				itemsTab: ['Segments','Media references & brand importance','Design','Materials & manufacturing', 'Chains'],
			}
		},		
		computed: {
			loading () {
				return this.$store.getters.loading
			},
			games () {
				const games = this.$store.getters.userData.games
				if (games) return Object.keys(games)
				else return []
			},
			currentGame () {
				return this.$store.getters.currentGame
			},
			gameId: {
				get () {
					return this.currentGame
				},
				set (val) {
					return val
				}
			},
			title () {
				return this.$route.name
			}
		},
		methods: {			
			link (item) {
				const name = item.split(' ')[0].toLowerCase()
				return `/admin/market/${name}`
			},
			chainRout () {
				return /\/market\/chains/.test(this.$route.path)
			},
			getInfo () {
				const chainRoute = this.chainRout()

				if (chainRoute) this.getChains()
				else this.getSegments()
			},
			async getSegments() {
				if(this.$refs.form.validate()) {
					const obj = {
						gameId: this.gameId,
						round: this.round
					}
					//console.log(obj)
					try {
						//get segments
						await this.$store.dispatch('fetchSegments', obj)	
					}
					catch (error) {
						throw error
					}
				}
			},
			async getChains() {
				if(this.$refs.form.validate()) {
					const obj = {
						gameId: this.gameId,
						round: this.round
					}
					//console.log(obj)
					try {
						//get chains
						await this.$store.dispatch('fetchIndependentChains', obj)	
					}
					catch (error) {
						throw error
					}
				}
			}
		},
		components: {
			Segments,
			Media,
			Materials,
			Chains,
			Design,
			addSegment,
			addChain
		}
	}
</script>
